// extracted by mini-css-extract-plugin
export default {"wrapper":"confirmation_wrapper__FRG+i","buttons":"confirmation_buttons__XrKRT","opacity-transition":"confirmation_opacity-transition__0rUT2"};